import React, { Component } from 'react';
import axios from 'axios';
import DataTable from './data-table';
import DataTableNotas from './data-table-notas';

export default class Notas extends Component {

    constructor(props) {
        super(props);
        this.state = { notasCollection: [] };
    }

    componentDidMount() {
        var url = "https://aguitech.casidios.com/panel/ws_notas_react.php";
        var params = {
            data1: 'holamundo',
        }
        //axios.get('http://aguitech.casidios.com/panel/ws_notas_react.php')
        axios.post(url, params)
            .then(res => {
                //console.log()
                //this.setState({ usersCollection: res.data });
                console.log(res.data.resultado);
                this.setState({ notasCollection: res.data.resultado });
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    dataTable() {
        return this.state.notasCollection.map((data, i) => {
            return <DataTable obj={data} key={i} />;
        });
    }
    dataTableNotas() {
        return this.state.notasCollection.map((data, i) => {
            return <DataTableNotas obj={data} key={i} />;
        });
    }

    render() {
        return (
            
                    <div className="wrapper-users">
                            <table className="table table-striped table-dark">
                                <thead className="thead-dark">
                                    <tr>
                                        <td>ID</td>
                                        <td>Name</td>
                                        <td>Email</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.dataTableNotas()}
                                </tbody>
                            </table>
                        
                    </div>
         
        )
    }
}
/*
{this.dataTable()}

<div className="container_full" style={{background: "red"}}>
*/